import { ClientLogs_request } from "./type";
import { IResponse } from "types/common";
import { ApiInstance } from "services/api/axios/apiInstance";
import ErrorHandlingUrls from "./urls";

const myAppSettingsObj = (window as any)["myAppSettings"];
const logBaseUrl: string = myAppSettingsObj.REACT_APP_BASE_LOG_API_URL!;
const ErrorHandlingService = {
  //post ...
  async ClientLogs(request: ClientLogs_request) {
    const response = await ApiInstance(
      false,
      undefined,
      logBaseUrl + ErrorHandlingUrls.clientLogs
    ).post<IResponse<null>>("", request);

    return response.data;
  },
};
export default ErrorHandlingService;
